module.exports = __webpack_public_path__ + "static/og_preview-68929e42107c63926f3d68e1c0552cc7.png";